// How the undo of Claude's effect edits rewrites and deletes an effect through v1 (untracked), then brings the renderer along

import { v1 } from '@/infrastructure/api/v1/client';
import type { VfxPort } from './sceneWrites';
import { untracked } from './sceneWrites';
import type { SceneSync } from './scenePorts';
import { read, removeRow } from './v1Rows';

/** The undo stack's port for effects. */
export function vfxPort(sync: SceneSync): VfxPort {
  return {
    async patch(id, fields) {
      const dto = await read(v1.PATCH('/api/v1/vfx-instances/{uniqueId}', { params: { path: { uniqueId: id } }, body: fields, headers: untracked.headers }));
      await sync.showUpdated({ vfxInstances: [dto] });
      return dto;
    },
    remove: id => removeRow(sync, v1.DELETE('/api/v1/vfx-instances/{uniqueId}', { params: { path: { uniqueId: id } }, headers: untracked.headers })),
  };
}
